import gql from 'graphql-tag';

export const getEventListQuery = gql`
  query allEvents(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: EventFilter
  ) {
    items: allEvents(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      name
      plot {
        id
        name
      }
      eventLocationId {
        id
        name
      }
      eventLocation {
        id
        name
      }
      eventDirector {
        id
        firstName
        lastName
        email
        role
        name
      }
      evidenceCode1
      evidenceCode2
      evidenceCode3
      evidenceCode4
      evidenceCode5
      evidenceCode6
      evidenceCode7
      evidenceCode8
      evidenceCode9
      evidenceCode10
      evidenceUnlock1
      evidenceUnlock2
      evidenceUnlock3
      evidenceUnlock4
      evidenceUnlock5
      evidenceUnlock6
      evidenceUnlock7
      evidenceUnlock8
      evidenceUnlock9
      evidenceUnlock10
      numberOfEvidence
      suspectsCode
      discountCode
      attendingActors
      eventCode
      eventCatId
      plotImage {
        url
      }
      status
      dressCode
      eventDate {
        date
        time
      }
      eventDateISO
      plotIntroduction
      createdAt
      updatedAt
      deletedAt
      __typename
    }
    total: _allEventsMeta(page: $page, perPage: $perPage, filter: $filter) {
      count
      __typename
    }
  }
`;
